module.exports = __webpack_public_path__ + "img/livestream-small.49ef1844.jpg";